/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Start_AuditInputs */

const en_audit_start_audit = /** @type {(inputs: Audit_Start_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Audit`)
};

const es_audit_start_audit = /** @type {(inputs: Audit_Start_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar Auditoria`)
};

/**
* | output |
* | --- |
* | "Start Audit" |
*
* @param {Audit_Start_AuditInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_start_audit = /** @type {((inputs?: Audit_Start_AuditInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Start_AuditInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_start_audit(inputs)
	return es_audit_start_audit(inputs)
});